class toggle {
	constructor(target){
		this.target = target;
		this.currentValue = this.target.querySelector('.js_toggle_current_select');
		this.mainBtn = this.target.querySelector('.js_toggle_btn');
		this.optionBtn = this.target.querySelectorAll('.js_toggle_option');
	}

	eventBind(){
		const _this = this;

		this.mainBtn.addEventListener('click', () => {
			//console.log(0);
			_this.selectOpenFn();
		});

		this.optionBtn.forEach(el => {
			el.addEventListener('click', () => {
				_this.selectedValueApplyFn(el);
			})
		});    
	}

	selectOpenFn(){
		this.mainBtn.classList.toggle('active');
	}

	selectedValueApplyFn(txt){
		this.mainBtn.classList.remove('active');
		this.mainBtn.innerHTML = txt.innerHTML;
		//this.currentValue.value = txt.innerText;
	}
}

document.addEventListener('DOMContentLoaded' , () =>{
	document.querySelectorAll('.js_toggle').forEach(el => {
        new toggle(el).eventBind();
    });
});
